import { Pipe, PipeTransform } from '@angular/core';
import { MxColumnPosition, MxColumnType } from 'src/app/shared/enums';

@Pipe({
  standalone: false,
  name: 'mxColumnPosition',
  pure: true,
})
export class MxColumnPositionPipe implements PipeTransform {
  constructor() {}

  transform(position: MxColumnPosition, columnType: MxColumnType): any {
    switch (position) {
      case MxColumnPosition.Start:
        return 'justify-content-start';
      case MxColumnPosition.Center:
        return 'justify-content-center';
      case MxColumnPosition.End:
        return 'justify-content-end';
      case MxColumnPosition.Between:
        return 'justify-content-between';
      case MxColumnPosition.Arround:
        return 'justify-content-arround';
      case MxColumnPosition.Evenly:
        return 'justify-content-evenly';
      default:
        if (
          columnType === MxColumnType.Number ||
          columnType === MxColumnType.Boolean ||
          columnType === MxColumnType.Date ||
          columnType === MxColumnType.DateTime
        ) {
          return 'justify-content-center';
        }
        return 'justify-content-start';
    }
  }
}
